import { render, staticRenderFns } from "./MemberAreaSetup.vue?vue&type=template&id=227de498&"
import script from "./MemberAreaSetup.vue?vue&type=script&lang=js&"
export * from "./MemberAreaSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports